import { useGlobalContext } from 'context/GlobalContext';
import ClientDetailsPage from 'features/order_client_details/ClientDetailsPage';
import React, { useEffect, useMemo, useState } from 'react';
import { ReactComponent as ColorDiamond } from "../assets/orderClient/color_diamond.svg";
import { ReactComponent as ColorGold } from "../assets/orderClient/color_gold.svg";
import { ReactComponent as ColorRings } from "../assets/orderClient/color_rings.svg";
import { ReactComponent as ColorCategory } from "../assets/orderClient/color_category.svg";
 
const ClientDetails = () => {
  const [filteredData, setFilteredData] = useState([]);
  const { setClientDetails, setClientDetailsComp, cartData } = useGlobalContext();
 
  const totalCalWeight = (type = "diamond") => {
    const total = cartData?.reduce((total, item) => {
      let weightStr = "";

      if (type === "diamond") {
        weightStr = item?.diaWt ||  item?.diaWeight || item?.diamond?.split(" Ct /")[0];
      }
      if (type === "gold") {
        weightStr = item?.netWeight || item?.netWt || item?.weight?.split(" g /")[0];
      }

      const weight = parseFloat(weightStr) || 0;
      return total + weight;
    }, 0);

    return total.toFixed(2);
  };
 
  useEffect(() => {
    setFilteredData(cartData || []);
  }, [cartData]);
 
  const categorySections = useMemo(() => {
    if (filteredData?.length > 0) { 
      const map = new Map();
      for (const item of filteredData) {
        if (!map.has(item.categoryName)) {
          map.set(item.categoryName, [item]);
        } else {
          map.get(item.categoryName).push(item);
        }
      }
      return [...map];
    }
    return [];
  }, [filteredData]);
 
  useEffect(() => {
    if (!filteredData || filteredData.length === 0) return;
 
    const OrderDetailsData = [
      {
        icon: <ColorDiamond />,
        label: "Diamond Weight",
        value: `${totalCalWeight("diamond")} Ct`,
      },
      {
        icon: <ColorGold />,
        label: "Gold Weight",
        value: `${totalCalWeight("gold")} g`,
      },
      {
        icon: <ColorRings />,
        label: "Design Count",
        value: cartData.length,
      },
      {
        icon: <ColorCategory />,
        label: "Categories",
        value: categorySections.length,
      },
    ];
    setClientDetails(OrderDetailsData);
    setClientDetailsComp(true);
 
    return () => {
      setClientDetailsComp(false);
    };
  }, [filteredData, categorySections]);

  return (
    <>
      <div style={{ margin: "0px 10px" }}>
        <ClientDetailsPage />
      </div>
    </>
  )
}

export default ClientDetails;